{
  "words": {
    "activity": "Activité",
    "createDate": "Date de création",
    "employee": "Employé",
    "activityHistory": "Historique d’activité"
  },
  "meta": {
    "vacancyList": "Mes offres d’emploi",
    "vacancyProfile": "Profil du poste",
    "vacancyCreate": "Création d’une offre d’emploi"
  },
  "activity": "Début du travail (ou période de travail pour les postes temporaires)",
  "notFound": "Aucune offre trouvée",
  "noVacancy": "Pas d’offres",
  "countingVacancy": "offres",
  "refreshActivity": {
    "success": "L’activité du poste a été mise à jour avec succès",
    "error": "Impossible de mettre à jour l’activité du poste"
  },
  "periodActivity": "",
  "dates": {
    "title": "Dates de l’offre",
    "createdAt": "Date de création",
    "expiresAt": "Date d’expiration",
    "notSet": "Non définie"
  },
  "breadcrumbs": {
    "vacancies": "Mes offres d’emploi"
  },
  "since": {
    "lowerCase": "à partir de",
    "upperCase": "À partir de"
  },
  "to": {
    "lowerCase": "jusqu’à",
    "upperCase": "Jusqu’à"
  },
  "template": {
    "title": "Modèle d’offres",
    "description": "Choisissez un modèle prêt à l’emploi déjà créé",
    "placeholder": "Sélectionnez"
  },
  "newVacancy": "Nouvelle offre d'emploi",
  "vacancy": {
    "status": {
      "new": "Nouvelle",
      "inProgress": "En cours de recrutement",
      "suspended": "Recrutement suspendu",
      "cancelled": "Recrutement annulé",
      "completed": "Recrutement terminé",
      "archived": "Archivé",
      "actions": {
        "launch": "Lancer",
        "suspend": "Suspendre",
        "cancel": "Annuler le recrutement"
      },
      "title": "Recherche de candidats",
      "error": "Impossible de modifier le statut du poste",
      "active": "Active",
      "activeCustom": {
        "actives": "Actives",
        "inactives": "Inactives",
        "always": "Toujours active",
        "period": "Active pour une période"
      },
      "inactive": "Inactive"
    },
    "create": "Créer une offre d’emploi"
  },
  "cleaningManager": "Gestionnaire de site de nettoyage",
  "header": {
    "createdDate": "Date de création :",
    "modifiedDate": "Date de modification",
    "deleteVacancy": "Supprimer l’offre"
  },
  "responsibleUser": {
    "title": "L’utilisateur",
    "description": ""
  },
  "filters": {
    "region": "Région"
  },
  "mainInfo": {
    "region": "Région",
    "city": "Ville",
    "activitySphere": "Métier",
    "interviewFinalMessage": "Message aux candidats intéressés"
  },
  "edit": {
    "template": {
      "title": "Modèle de descriptif de poste à adapter",
      "description": ""
    },
    "interviewFinalMessage": {
      "title": "Message aux candidats",
      "description": "Ce message sera envoyé aux candidats que vous sélectionnez. Vous pouvez y préciser les prochaines étapes ou toute information utile.",
      "placeholder": ""
    },
    "region": {
      "title": "Région",
      "description": "Adresse où travaillera l’employé"
    },
    "city": {
      "title": "Ville",
      "description": "Adresse où travaillera l’employé"
    },
    "activitySphere": {
      "title": "Métier",
      "description": "Sélectionnez tous les métiers correspondant au poste",
      "placeholder": "Sélectionnez",
      "autoFill": "Renseigner automatiquement"
    }
  },
  "create": {
    "minPeriodActivityError": "La date de début doit être supérieure ou égale à la date actuelle",
    "periodActivityFromError": "Champ obligatoire",
    "periodActivityToError": "Champ obligatoire"
  },
  "generate": {
    "chatCreate": "Créer avec Cynthia",
    "chatMessage": "Bonjour Cynthia, je souhaite créer une offre d’emploi.",
    "button": "Générer l’offer",
    "manualCreate": "Renseigner l’offre",
    "title": "Génération d'offre d'emploi",
    "pending": "Veuillez patienter — nous créons votre offre d'emploi sur la base de votre demande",
    "error": "Nous n'avons pas pu générer d'offre d'emploi pour votre demande",
    "close": "Fermer",
    "cancel": "Annuler",
    "submit": "Générer",
    "vacancyName": {
      "label": "Titre du poste",
      "description": "Nom du poste à pourvoir. Nombre maximum de caractères : 250",
      "placeholder": "Entrez le titre",
      "maxLength": "Nombre maximum de caractères dépassé"
    },
    "generationRequest": {
      "label": "Demande de génération",
      "description": "Décrivez le poste en termes simples : qui vous cherchez, quelles tâches et conditions. Synthia générera l'offre sur la base de votre demande. Nombre maximum de caractères : 3000",
      "placeholder": "Entrez votre demande de génération librement",
      "required": "Entrez votre demande de génération librement",
      "maxLength": "Nombre maximum de caractères dépassé"
    }
  },
  "tariff": {
    "title": "Tarif",
    "show": "Afficher",
    "hide": "Masquer",
    "costLine1": "Coût",
    "costLine2": "par candidat sélectionné",
    "selectTariffAria": "Choisir le tarif",
    "loadError": "Impossible de charger les tarifs",
    "noTariffs": "Aucun tarif disponible",
    "historyTitle": "Historique des modifications",
    "historyAria": "Historique des modifications du tarif",
    "columnActivationDate": "Date d’activation",
    "columnTariffName": "Nom du tarif",
    "modalTitle": "Choisir le tarif",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "back": "Retour"
  },
  "ratingBanner": {
    "summary": "Un retour est demandé · {{count}}",
    "previous": "Demande précédente",
    "next": "Demande suivante",
    "hired": {
      "question": "Le candidat a-t-il été embauché pour le poste : {{vacancyName}} ?"
    },
    "interview": {
      "question": "L'entretien avec le candidat pour le poste : {{vacancyName}} a-t-il eu lieu ?",
      "cancellationModal": {
        "title": "Indiquez la raison",
        "description": "Veuillez indiquer la raison de l'entretien non réalisé",
        "cancel": "Annuler",
        "submit": "Envoyer"
      }
    },
    "yes": "Oui",
    "no": "Non",
    "candidateDetails": {
      "contactPhone": "Téléphone de contact"
    },
    "rejection": {
      "questionBeforeName": "Veuillez indiquer la raison du refus du candidat ",
      "questionAfterName": " pour le poste : {{vacancyName}} ?",
      "description": "Indiquez la raison pour laquelle le candidat n'a pas été embauché, cela prendra moins d'une minute. Le candidat ne verra pas votre réponse",
      "leaveAnswer": "Laisser une réponse",
      "remindLater": "Rappeler plus tard",
      "skip": "Passer",
      "form": {
        "title": "Raison du refus",
        "checkboxHint": "Cochez les affirmations appropriées",
        "reasonRequired": "Sélectionnez au moins une raison",
        "commentLabel": "Commentaire",
        "commentDescription": "Ajoutez un commentaire si vous le souhaitez. Nombre maximal de caractères — {{max}}",
        "commentPlaceholder": "Saisissez un commentaire",
        "commentMaxLength": "Nombre maximal de caractères dépassé",
        "cancel": "Annuler",
        "submit": "Envoyer"
      },
      "successModal": {
        "title": "Merci pour votre réponse !",
        "description": "Nous en tiendrons compte pour améliorer notre service de sélection de candidats",
        "confirm": "OK"
      }
    },
    "review": {
      "questionBeforeName": "Évaluez le travail du candidat ",
      "questionAfterName": " pour le poste : {{vacancyName}} ?",
      "description": "Laissez un avis sur le candidat, cela prendra moins d'une minute. Le candidat ne verra pas votre avis",
      "leaveReview": "Laisser un avis",
      "remindLater": "Rappeler plus tard",
      "skip": "Passer",
      "form": {
        "title": "Avis sur le candidat",
        "checkboxHint": "Cochez les affirmations appropriées",
        "commentLabel": "Commentaire",
        "commentDescription": "Ajoutez un commentaire si vous le souhaitez. Nombre maximal de caractères — {{max}}",
        "commentPlaceholder": "Saisissez un commentaire",
        "commentMaxLength": "Nombre maximal de caractères dépassé",
        "cancel": "Annuler",
        "submit": "Envoyer"
      },
      "successModal": {
        "title": "Merci pour votre avis !",
        "description": "Nous en tiendrons compte pour améliorer notre service de sélection de candidats",
        "confirm": "OK"
      }
    }
  }
}
